import React from "react";
import { Typography } from "antd";
import { useIntl } from "react-intl";
import VerticalItem from "../../../components/print/workDiary/VerticalItem";
import {
  getLocalPhoneNumber,
  getFullName,
} from "../../../components/util/helpers";
const { Title } = Typography;

const EmployeeDetails = (props) => {
  const { employee } = props;
  const intl = useIntl();

  const street =
    employee && employee["address"] && employee["address"]["street"]
      ? `${employee["address"]["street"].trim()} ${
          employee["address"]["house_number"]
        }`
      : "-";
  const city =
    employee && employee["address"] && employee["address"]["city"] !== undefined
      ? employee["address"]["city"]
      : "-";
  const fullName = employee
    ? getFullName(employee.surename, employee.first_name)
    : "-";
  const truncate = (input, num) =>
    input.length > num ? `${input.substring(0, num)}` : input;
  return (
    <div className="borderedSection" style={{ width: "100%" }}>
      <Title level={5}>
        {intl.formatMessage({
          id: "app.work_diary_print.employee_details",
        })}
      </Title>
      <div style={{ width: "max-content" }}>
        <VerticalItem
          content={truncate(fullName, 17)}
          style={{ fontWeight: "bold", fontSize: "1.15em" }}
        />
        <VerticalItem
          content={
            employee &&
            employee.accounting_info &&
            employee.accounting_info.number
              ? employee.accounting_info.number
              : "-"
          }
        />
        <VerticalItem content={employee ? employee.local_id_number : "-"} />
        <VerticalItem content={truncate(city, 19)} />
        <VerticalItem content={truncate(street, 19)} />
        <VerticalItem
          content={
            employee && employee.contact_info
              ? getLocalPhoneNumber(
                  employee.contact_info.mobile_number
                    ? employee.contact_info.mobile_number
                    : employee.contact_info.phone_number
                )
              : "-"
          }
        />
      </div>
    </div>
  );
};

export default EmployeeDetails;
